import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { AUTOSAVE_SAVED } from '@/types/flow.type';

import { FlowBuilderSliceState } from './flowBuilder.type';

const flowBuilderInitialState: FlowBuilderSliceState = {
    autosaveStatus: AUTOSAVE_SAVED,
};

export const FLOW_BUILDER_REDUCER_NAME = 'flowBuilder';

export const flowBuilderSlice = createSlice({
    name: FLOW_BUILDER_REDUCER_NAME,
    initialState: flowBuilderInitialState,
    reducers: {
        setAutosaveStatus: (
            state,
            action: PayloadAction<FlowBuilderSliceState['autosaveStatus']>,
        ) => {
            state.autosaveStatus = action.payload;
        },
    },
});

export const { setAutosaveStatus } = flowBuilderSlice.actions;

export const flowBuilderReducer = flowBuilderSlice.reducer;
